import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Cargando from '../../Varios/Cargando';
import { SolicitudesPermisosPorRevisarTH } from './TypesRevisionSolicitudes';
import TablaRevisionSolicitudes from './TablaRevisionSolicitudes';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';

import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import ModalRechazo from 'components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud';
import { alertService } from 'components/Varios/alert_service';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ResponseRequest } from 'components/Types/GeneralTypes';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import Swal from 'sweetalert2';

import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"
import AnuncioSVG from "assets/icons/Permisos/Anuncio.svg"
import { ObtenerInformacionRevisiones, VistaPreviaSolicitudLicencias, AnularAccionPersonalLicencia, RevisarSolicitudLicencias } from './FunctionsRevisiones';

type StateRevisionSolicitudes = {
    filasTabla: SolicitudesPermisosPorRevisarTH[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    mensajeError: string | undefined,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalInformacionRevisarPermisos = {
    url: string,
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    tituloModal: string
}

type StateModalInformacionRechazar = {
    cargando: boolean,
    idSolicitud: number,
    modalContent: HTMLElement | undefined,
    observacion: string
}

export function showAlertSwal(message: string, isSuccess: boolean) {
    Swal.fire({
        text: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertHTMLSwal(message: string, isSuccess: boolean) {
    Swal.fire({
        html: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertSwalAnuncio(message: string) {
    Swal.fire({
        text: message,
        imageUrl: `${AnuncioSVG}`,
        imageHeight: 100, // Ajusta el tamaño según sea necesario
        imageAlt: "Anuncio",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export default function RevisionSolicitudes() {
    const TITULO_REVISION_SOLICITUDES = "REVISIÓN DE AP DE LICENCIAS";

    const defaulState: StateRevisionSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        mensajeError: undefined,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateModalRevisarLicencias: StateModalInformacionRevisarPermisos = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        tituloModal: "Revisión de AP de Licencias"
    }    

    const defaultStateModalInformacionAnular: StateModalInformacionRechazar = {
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        observacion: ""
    }

    const [stateRevision, setstateRevision] = useState<StateRevisionSolicitudes>(defaulState)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const [stateinformacionModalRevisarAP, setstateinformacionModalRevisarAP] = useState(defaultStateModalRevisarLicencias)    
    const [stateinformacionModalAnular, setstateinformacionModalAnular] = useState(defaultStateModalInformacionAnular)

    const [observacion, setobservacion] = useState("");

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function ObtenerDatosRevisiones() {
        setstateRevision({ ...stateRevision, loadingFilas: true })
        const resultado = await ObtenerInformacionRevisiones()
        if (resultado.status === 200) {
            if (typeof (resultado.dataResponse) === "string") {
                setstateRevision({ ...stateRevision, mensajeAprobacion: resultado.dataResponse, loadingFilas: false })
            }
            else {
                setstateRevision({ ...stateRevision, filasTabla: resultado.dataResponse, loadingFilas: false })
            }

        } else {
            setstateRevision(prev => ({ ...prev, mensajeError: resultado.errorMessage, loadingFilas: false, errorFilas: true }));

        }

    }
    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])

    useEffect(() => {
        ObtenerDatosRevisiones();
    }, [])
    
    async function OnCloseModalAnulacion() {
        await ObtenerDatosRevisiones()
        setstateinformacionModalAnular(defaultStateModalInformacionAnular)
        ScrollToTop();
    }

    async function OnCloseModalRevision() {
        setstateinformacionModalRevisarAP(defaultStateModalRevisarLicencias)        
        await ObtenerDatosRevisiones()
        ScrollToTop();
    }

    const tablaRevisiones = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla, mensajeError } = stateRevision
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas && mensajeError === undefined) {
            return <div>No ha sido posible cargar la información</div>
        } else if (!loadingFilas && errorFilas && mensajeError) {
            return <div className="alert alert-danger">{mensajeError}</div>;
        }
        else if (filasTabla.length > 0) {
            return (
                <TablaRevisionSolicitudes
                    dataFilas={stateRevision.filasTabla}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickRechazar={(solicitud: any) => onClickAnularAccionPersonal(solicitud)}                    
                    onClickRevisar={(solicitud: any) => onClickAprobarParcialmenteSolicitudPermisos(solicitud)}
                />

            )

        }
        else {
            return (
                <TablaRevisionSolicitudes
                    dataFilas={[]}
                    onClickVerDocumento={async (referencia: string) => { ; }}
                    onClickRechazar={(solicitud: any) => { ; }}
                    onClickRevisar={(solicitud: any) => { ; }}
                />
            )
        }

    }, [stateRevision])

    function onClickAnularAccionPersonal(informacionAcciones) {

        const modalContent = AuxiliarGenerarHTMLBodyModalAnular(informacionAcciones);

        setstateinformacionModalAnular({
            cargando: false,
            idSolicitud: informacionAcciones.idPermiso,
            modalContent,
            observacion
        })
    }

    async function onClickAprobarParcialmenteSolicitudPermisos(informacionAcciones) {        
        var titulo = "";
        var respuestaSolicitud: ResponseRequest = { status: -1 };
        respuestaSolicitud = await VistaPreviaSolicitudLicencias(informacionAcciones.idPermiso);
        if (respuestaSolicitud.status === 200) {
            var content: any = undefined;
            titulo = "Acción de Personal de Licencia"
            setstateinformacionModalRevisarAP({
                url: respuestaSolicitud.dataResponse,
                cargando: false,
                tituloModal: titulo,
                modalContent: content,
                idSolicitud: informacionAcciones.idPermiso
            })
        }
        else {
            alertService.error(respuestaSolicitud.errorMessage ?? "");
        }        
    }

    async function OnClickAccionModalFormulario(idSolicitud) {
        setstateinformacionModalRevisarAP({ ...defaultStateModalRevisarLicencias, cargando: true })
        var accionRealizada = await RevisarSolicitudLicencias(idSolicitud)
        setstateinformacionModalRevisarAP(defaultStateModalRevisarLicencias)
        await ObtenerDatosRevisiones();
    }
    function AuxiliarGenerarHTMLBodyModalAnular(informacionAcciones): any {
        return (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaInicio)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaFin)}
                                </div>

                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.tiempo}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>

                            </td>

                        </tr>

                    </tbody>
                </Table>
            </>
        )
    }

    async function AnularAP(idSolicitud, observacion) {
        const respuesta = await AnularAccionPersonalLicencia(idSolicitud, observacion)
        if (respuesta.status !== 200) {
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
            return 1;
        }
        else {
            await showAlert("Se ha anulado la Acción de Personal de Licencia", ExitoSVG, true);
            return -1
        }
    }

    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> {TITULO_REVISION_SOLICITUDES} </div>
            {tablaRevisiones}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de permisos y/o licencias'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

            <ModalRechazo
                show={stateinformacionModalAnular.idSolicitud > 0 || stateinformacionModalAnular.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAnular(defaultStateModalInformacionAnular)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea anular la acción de personal?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => AnularAP(stateinformacionModalAnular.idSolicitud, { Observacion: observacion })}
                contentModal={stateinformacionModalAnular.modalContent}
                tituloModal={"Anular Acción de Personal"}
                asyncAfterOnClose={() => OnCloseModalAnulacion()}
                labelObservacion={"Indique el motivo de anulación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            />

            <ModalConfirmacion
                show={stateinformacionModalRevisarAP.idSolicitud > 0 || stateinformacionModalRevisarAP.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRevisarAP(defaultStateModalRevisarLicencias)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea validar la solicitud de permiso?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => RevisarSolicitudLicencias(stateinformacionModalRevisarAP.idSolicitud)}
                contentModal={stateinformacionModalRevisarAP.modalContent}
                tituloModal={stateinformacionModalRevisarAP.tituloModal}
                asyncAfterOnClose={() => OnCloseModalRevision()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}
            />

            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalRevisarAP.url !== "" || stateinformacionModalRevisarAP.cargando}
                onClose={() => setstateinformacionModalRevisarAP(defaultStateModalRevisarLicencias)}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalRevisarAP.cargando}
                size="xl"
                tituloModal={stateinformacionModalRevisarAP.tituloModal}
                urlArchivo={stateinformacionModalRevisarAP.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalRevisarAP.idSolicitud)}
                disabledbuttonCondition={stateinformacionModalRevisarAP.cargando}
                modalContent={stateinformacionModalRevisarAP.modalContent}
            />
        </div>
    )

}